/**
 * Rocket Search — Galaxy (único plano Rocket no catálogo).
 * R$ 1.900,00/mês | promo implantação até 12/06.
 */

export const ROCKET_SEARCH_GALAXY_NAME = 'Rocket Search - Galaxy'

export const ROCKET_GALAXY_CATEGORIES = {
  busca: 'Busca Inteligente & Navegação',
  ia: 'IA & Machine Learning',
  vitrines: 'Vitrines Inteligentes',
  avaliacoes: 'Avaliações de Produtos',
  analytics: 'Analytics Avançados',
  api: 'Integração Via API',
} as const

export const ROCKET_GALAXY_CATEGORY_COORDS = {
  [ROCKET_GALAXY_CATEGORIES.busca]: { x: 38, y: 18 },
  [ROCKET_GALAXY_CATEGORIES.ia]: { x: 68, y: 18 },
  [ROCKET_GALAXY_CATEGORIES.vitrines]: { x: 38, y: 46 },
  [ROCKET_GALAXY_CATEGORIES.avaliacoes]: { x: 68, y: 46 },
  [ROCKET_GALAXY_CATEGORIES.analytics]: { x: 38, y: 74 },
  [ROCKET_GALAXY_CATEGORIES.api]: { x: 68, y: 74 },
} as const

/** Posições travadas no Proposal Studio (controles 1–20). */
export const ROCKET_GALAXY_PROPOSAL_LAYOUT = {
  leftBlockWidth: 35,
  titleY: 4.6,
  projectTypeY: 23.2,
  descriptionY: 29.3,
  supportHoursY: 47,
  bonusY: 58,
  priceY: 75.3,
  paymentY: 84.5,
  loyaltyY: 94,
  negotiationY: 93.2,
  planTitleY: 4,
  serviceBlockStartY: 18,
  serviceBlockX: 38,
  serviceBlockGap: 68,
  categoryCoords: { ...ROCKET_GALAXY_CATEGORY_COORDS },
} as const

export const rocketGalaxyDeliverables = [
  {
    name: 'Busca semãntica e contextual',
    category: ROCKET_GALAXY_CATEGORIES.busca,
    quantity: 'Contínuo',
    hours: 0,
  },
  { name: 'Sinônimos e correção ortográfica', category: ROCKET_GALAXY_CATEGORIES.busca, quantity: 'Contínuo', hours: 0 },
  { name: 'Autocomplete e busca por SKU', category: ROCKET_GALAXY_CATEGORIES.busca, quantity: 'Contínuo', hours: 0 },
  { name: 'Filtros e facetas inteligentes', category: ROCKET_GALAXY_CATEGORIES.busca, quantity: 'Contínuo', hours: 0 },
  {
    name: 'Personalização por comportamento',
    category: ROCKET_GALAXY_CATEGORIES.ia,
    quantity: 'Contínuo',
    hours: 0,
  },
  { name: 'Ranking inteligente', category: ROCKET_GALAXY_CATEGORIES.ia, quantity: 'Contínuo', hours: 0 },
  { name: 'Localização, estoque e margem', category: ROCKET_GALAXY_CATEGORIES.ia, quantity: 'Contínuo', hours: 0 },
  { name: 'Aprendizado contínuo', category: ROCKET_GALAXY_CATEGORIES.ia, quantity: 'Contínuo', hours: 0 },
  { name: 'Mais vendidos e lançamentos', category: ROCKET_GALAXY_CATEGORIES.vitrines, quantity: 'Contínuo', hours: 0 },
  { name: 'Cross-sell e upsell', category: ROCKET_GALAXY_CATEGORIES.vitrines, quantity: 'Contínuo', hours: 0 },
  { name: 'Campanhas e promoções', category: ROCKET_GALAXY_CATEGORIES.vitrines, quantity: 'Contínuo', hours: 0 },
  { name: 'Kits e quem viu também comprou', category: ROCKET_GALAXY_CATEGORIES.vitrines, quantity: 'Contínuo', hours: 0 },
  { name: 'Nota por estrelas', category: ROCKET_GALAXY_CATEGORIES.avaliacoes, quantity: 'Contínuo', hours: 0 },
  { name: 'Fotos dos clientes', category: ROCKET_GALAXY_CATEGORIES.avaliacoes, quantity: 'Contínuo', hours: 0 },
  { name: 'Respostas da loja', category: ROCKET_GALAXY_CATEGORIES.avaliacoes, quantity: 'Contínuo', hours: 0 },
  { name: 'Moderação inteligente', category: ROCKET_GALAXY_CATEGORIES.avaliacoes, quantity: 'Contínuo', hours: 0 },
  { name: 'Receita da busca', category: ROCKET_GALAXY_CATEGORIES.analytics, quantity: 'Contínuo', hours: 0 },
  { name: 'Conversão e ticket médio', category: ROCKET_GALAXY_CATEGORIES.analytics, quantity: 'Contínuo', hours: 0 },
  { name: 'Funil da busca', category: ROCKET_GALAXY_CATEGORIES.analytics, quantity: 'Contínuo', hours: 0 },
  { name: 'Termos sem resultado', category: ROCKET_GALAXY_CATEGORIES.analytics, quantity: 'Contínuo', hours: 0 },
  { name: 'Conexão com qualquer plataforma', category: ROCKET_GALAXY_CATEGORIES.api, quantity: 'Contínuo', hours: 0 },
  {
    name: 'Sincronização automática',
    category: ROCKET_GALAXY_CATEGORIES.api,
    quantity: 'Contínuo',
    hours: 0,
  },
  {
    name: 'Segurança e confiabilidade',
    category: ROCKET_GALAXY_CATEGORIES.api,
    quantity: 'Contínuo',
    hours: 0,
  },
  { name: 'Suporte completo de integração', category: ROCKET_GALAXY_CATEGORIES.api, quantity: 'Contínuo', hours: 0 },
] as const

function buildRocketGalaxyServices() {
  const byCategory = new Map<string, { name: string; isIncluded: boolean }[]>()
  for (const d of rocketGalaxyDeliverables) {
    const list = byCategory.get(d.category) ?? []
    list.push({ name: d.name, isIncluded: true })
    byCategory.set(d.category, list)
  }
  return Array.from(byCategory.entries()).map(([category, services]) => ({
    category,
    services,
  }))
}

export function buildRocketSearchGalaxyConfig() {
  const deliverables = rocketGalaxyDeliverables.map((d) => ({ ...d }))
  const monthly = 1900

  return {
    showBonus: true,
    bonus: 'Sem custo de implantação para fechamentos até 12/06',
    duration: 12,
    hourlyRate: 0,
    totalHours: 0,
    suggestedValue: monthly,
    observations: 'Mensalidade R$ 1.900,00. Implantação promocional sem custo para fechamentos até 12/06.',
    pricing: {
      entry: 0,
      total: monthly * 12,
      installments: 12,
      installmentValue: monthly,
      recorrente: true,
      duracao: 12,
    },
    services: buildRocketGalaxyServices(),
    deliverables,
    proposalLayout: { ...ROCKET_GALAXY_PROPOSAL_LAYOUT },
  }
}

export const rocketSearchGalaxyPlanSeed = {
  name: ROCKET_SEARCH_GALAXY_NAME,
  description:
    'Plano Galaxy do Rocket Search: busca inteligente, IA e machine learning, vitrines inteligentes, ' +
    'avaliações de produtos, analytics avançados e integração via API. R$ 1.900,00/mês. ' +
    'Implantação promocional sem custo para fechamentos até 12/06.',
  baseValue: 1900.0,
  category: 'Rocket',
  type: 'RECORRENTE' as const,
  isActive: true,
  config: buildRocketSearchGalaxyConfig(),
}
